import { applyReactInVue } from 'vuereact-combined';

import { BillingUsageInvoiceHistory } from '@/react_app/components/BillingUsage/InvoiceHistory';
import { BillingUsageOverview } from '@/react_app/components/BillingUsage/Overview';
import { BillingUsagePaymentMethods } from '@/react_app/components/BillingUsage/PaymentMethods';
import { BillingUsageSettings } from '@/react_app/components/BillingUsage/Settings';
import {
	BillingUsageHistoryLayout,
	BillingUsageHistoryAutomation,
	BillingUsageHistoryPlyCredits,
	BillingUsageHistoryTeamFeatures,
	BillingUsageHistoryCustomerFeatures,
} from '@/react_app/components/BillingUsage/UsageHistory';
import {
	BILLING_USAGE_ROUTE_NAME,
	BILLING_USAGE_HISTORY_ROUTE_NAME,
	BILLING_USAGE_OVERVIEW_ROUTE_NAME,
	BILLING_USAGE_SETTINGS_ROUTE_NAME,
	BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME,
	BILLING_USAGE_INVOICE_HISTORY_ROUTE_NAME,
	BILLING_USAGE_HISTORY_AUTOMATION_ROUTE_NAME,
	BILLING_USAGE_HISTORY_PLY_CREDITS_ROUTE_NAME,
	BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME,
	BILLING_USAGE_HISTORY_CUSTOMER_FEATURES_ROUTE_NAME,
} from '@/router/BillingUsage/billing-usage-router.const';
import BillingUsageLayoutDataInitializer from '@/views/BillingUsageLayoutDataInitializer.vue';
const BillingUsageRouter = {
	path: 'usage',
	meta: { noContentPadding: true },
	name: BILLING_USAGE_ROUTE_NAME,
	component: BillingUsageLayoutDataInitializer,
	redirect: { name: BILLING_USAGE_OVERVIEW_ROUTE_NAME },
	children: [
		{
			path: 'overview',
			name: BILLING_USAGE_OVERVIEW_ROUTE_NAME,
			component: applyReactInVue(BillingUsageOverview),
		},
		{
			path: 'usage-history',
			name: BILLING_USAGE_HISTORY_ROUTE_NAME,
			component: applyReactInVue(BillingUsageHistoryLayout),
			redirect: { name: BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME },
			children: [
				{
					path: 'team-features',
					name: BILLING_USAGE_HISTORY_TEAM_FEATURES_ROUTE_NAME,
					component: applyReactInVue(BillingUsageHistoryTeamFeatures),
				},
				{
					path: 'customer-features',
					name: BILLING_USAGE_HISTORY_CUSTOMER_FEATURES_ROUTE_NAME,
					component: applyReactInVue(BillingUsageHistoryCustomerFeatures),
				},
				{
					path: 'automation',
					name: BILLING_USAGE_HISTORY_AUTOMATION_ROUTE_NAME,
					component: applyReactInVue(BillingUsageHistoryAutomation),
				},
				{
					path: 'ply-credits',
					name: BILLING_USAGE_HISTORY_PLY_CREDITS_ROUTE_NAME,
					component: applyReactInVue(BillingUsageHistoryPlyCredits),
				},
			],
		},
		{
			path: 'settings',
			name: BILLING_USAGE_SETTINGS_ROUTE_NAME,
			component: applyReactInVue(BillingUsageSettings),
		},
		{
			path: 'payment-methods',
			name: BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME,
			component: applyReactInVue(BillingUsagePaymentMethods),
		},
		{
			path: 'invoice-history',
			name: BILLING_USAGE_INVOICE_HISTORY_ROUTE_NAME,
			component: applyReactInVue(BillingUsageInvoiceHistory),
		},
	],
};

export default BillingUsageRouter;
